var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.customerIsNotActive())?_c('div',[_c('os-alert-box',{staticClass:"mb-2"},[_c('div',{staticClass:"body-1 d-flex justify-space-between align-center"},[_c('div',[_vm._v("This customer is "+_vm._s(_vm.internalCustomerState?.toLowerCase())+".")])])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }